import { render, staticRenderFns } from "./InstrumentsStatCard.vue?vue&type=template&id=3c3ebfa7&scoped=true&"
import script from "./InstrumentsStatCard.vue?vue&type=script&lang=js&"
export * from "./InstrumentsStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ebfa7",
  null
  
)

export default component.exports